import { z } from "zod";

const UpdateRolePermissionsSchema = z.object({
  roleId: z.number().int().positive(),
  featureId: z.number().int().positive(),
  isActive: z.boolean(),
  permissionId: z.number().int().positive().optional(),
});

export type UpdateRolePermissionsDTOShape = z.infer<
  typeof UpdateRolePermissionsSchema
>;

export class UpdateRolePermissionsDTO {
  readonly roleId!: number;
  readonly featureId!: number;
  readonly isActive!: boolean;
  readonly permissionId?: number;

  constructor(data: UpdateRolePermissionsDTOShape) {
    const validated = UpdateRolePermissionsSchema.parse(data);
    Object.assign(this, validated);
  }

  static validate(data: unknown) {
    return UpdateRolePermissionsSchema.safeParse(data);
  }
}
